export const PERCENTAGE_HUB = {
    label: 'Percentage Calculator',
    path: '/percentage/',
}

export const PERCENTAGE_SPOKES = [
    { label: 'Percentage Increase', path: '/percentage-increase-calculator/' },
    { label: 'Percentage Decrease', path: '/percentage-decrease-calculator/' },
    { label: 'Discount Calculator', path: '/discount-calculator/' },
    { label: 'Tax Calculator', path: '/tax-calculator/' },
    { label: 'Tip Calculator', path: '/tip-calculator/' },
    { label: 'Marks Percentage', path: '/marks-percentage-calculator/' },
    { label: 'GPA / CGPA Calculator', path: '/gpa-calculator/' },
]